@if (savedBillingContract) {
	<app-tab-navigation-header
		title="Company"
		i18n-title="@@billingContractDetails-companyTitle"
		detail="{{ savedBillingContract.company.name }}"
	>
		<mat-tab-group appQueryStringTabGroup>
			<mat-tab i18n-label="@@billingContractDetails-details" label="Details" data-automation-id="details-tab">
				@if (savedBillingContract) {
					<div class="billing-contract-container" [appBreadcrumbLabel]="savedBillingContract.company.name">
						<!-- Viewing the bill settings -->
						@if (!editingBillingSettings) {
							<app-billing-edit-contract
								[billingContract]="savedBillingContract"
								[userAction]="'viewing'"
							></app-billing-edit-contract>
						}
						<!-- Editing the bill settings -->
						@if (editingBillingSettings) {
							<app-billing-edit-contract
								[billingContract]="savedBillingContract"
								[userAction]="'editing'"
							></app-billing-edit-contract>
						}
					</div>
				}
			</mat-tab>
		</mat-tab-group>
	</app-tab-navigation-header>
}
